module.exports = __webpack_public_path__ + "static/media/yellowmachine--logo.0f8c0552.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/pages/porfolio/yellowmachine/yellowmachine--logo.png
// module id = 171
// module chunks = 0